<script>
import {defineComponent} from 'vue'
import {Link} from "@inertiajs/vue3";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import IconPaymentVisa from "@js/components/Icons/IconPaymentVisa.vue";
import IconPaymentMasterCard from "@js/components/Icons/IconPaymentMasterCard.vue";
import IconPaymentMir from "@js/components/Icons/IconPaymentMir.vue";
import IconPaymentSbp from "@js/components/Icons/IconPaymentSbp.vue";
import IconPaymentMaestro from "@js/components/Icons/IconPaymentMaestro.vue";
import IconCalculator from "@js/components/Icons/IconCalculator.vue";
import IconCheckMark from "@js/components/Icons/IconCheckMark.vue";
import IconDeliveryCar from "@js/components/Icons/IconDeliveryCar.vue";
import {useCallbackStore} from "@js/store/CallbackStore.js";

export default defineComponent({
    name: "PaymentPage",
    components: {
        Link,
        MobileTopBar,
        Breadcrumbs,
        IconPaymentVisa,
        IconPaymentMasterCard,
        IconPaymentMir,
        IconPaymentSbp,
        IconPaymentMaestro,
        IconCalculator,
        IconCheckMark,
        IconDeliveryCar,
    },
    setup() {
        const callbackStore = useCallbackStore()

        return {callbackStore}
    },
    data() {
        return {
            paymentSteps: [
                {
                    number: '01',
                    title: 'Заявка',
                    text: 'Вы отправляете список материалов или выбираете товары в каталоге.'
                },
                {
                    number: '02',
                    title: 'Расчет',
                    text: 'Менеджер уточняет объем, наличие, сроки и адрес доставки.'
                },
                {
                    number: '03',
                    title: 'Оплата',
                    text: 'Вы получаете счет или ссылку и оплачиваете заказ удобным способом.'
                },
                {
                    number: '04',
                    title: 'Поставка',
                    text: 'После оплаты организуем отгрузку, доставку или самовывоз.'
                },
            ],
            conditions: [
                'Цена фиксируется после согласования заказа и выставления счета.',
                'Отгрузка выполняется после поступления оплаты или по индивидуальным условиям.',
                'Доставка рассчитывается отдельно с учетом адреса, объема и типа материалов.',
                'Для крупных заказов возможны индивидуальные условия оплаты.',
            ],
            documents: [
                'Договор поставки',
                'Счет на оплату',
                'УПД или товарная накладная',
                'Счет-фактура при работе с НДС',
            ]
        }
    }
});
</script>

<template>
    <MobileTopBar/>

    <div class="container mb-5 md:mb-10">
        <Breadcrumbs/>

        <section class="relative overflow-hidden rounded-2xl md:rounded-3xl bg-grayBg border border-gray-200 mb-5 md:mb-8">
            <div class="grid lg:grid-cols-[1.05fr_0.95fr] gap-4 md:gap-6 p-4 md:p-8 lg:p-10">
                <div>
                    <div class="inline-flex items-center rounded-full bg-white border border-gray-200 px-3 md:px-4 py-2 text-[11px] md:text-xs font-semibold mb-4 md:mb-5">
                        Оплата заказов
                    </div>

                    <h1 class="text-2xl md:text-5xl font-bold leading-tight mb-4 md:mb-5">
                        Способы оплаты строительных материалов
                    </h1>

                    <p class="text-sm md:text-base text-gray-700 max-w-3xl mb-5 md:mb-6">
                        Работаем с физическими и юридическими лицами. После согласования заявки подготовим расчет,
                        выставим счет или отправим ссылку для оплаты.
                    </p>

                    <div class="flex flex-wrap gap-3">
                        <button
                            @click.prevent="callbackStore.showBaseCallbackPopup"
                            class="max-md:w-full flex justify-center items-center text-center border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-xs md:text-sm px-5 md:px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                            Получить счет
                        </button>

                        <Link :href="route('priceList')"
                              class="max-md:w-full flex justify-center items-center text-center border-2 border-baseColor bg-transparent md:hover:bg-baseColor font-bold rounded-lg text-xs md:text-sm px-5 md:px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                            Прайс-лист
                        </Link>
                    </div>
                </div>

                <div class="bg-white border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-6">
                    <h2 class="text-lg md:text-2xl font-bold mb-4">
                        Доступные способы
                    </h2>

                    <div class="grid grid-cols-2 gap-3 mb-5">
                        <div class="rounded-xl bg-grayBg border border-gray-200 p-3 md:p-4">
                            <div class="text-base md:text-xl font-bold">Наличные</div>
                            <div class="text-[11px] md:text-xs text-gray-600 mt-1">по согласованию</div>
                        </div>

                        <div class="rounded-xl bg-grayBg border border-gray-200 p-3 md:p-4">
                            <div class="text-base md:text-xl font-bold">Карта</div>
                            <div class="text-[11px] md:text-xs text-gray-600 mt-1">VISA, МИР, MasterCard</div>
                        </div>

                        <div class="rounded-xl bg-grayBg border border-gray-200 p-3 md:p-4">
                            <div class="text-base md:text-xl font-bold">СБП</div>
                            <div class="text-[11px] md:text-xs text-gray-600 mt-1">быстрый перевод</div>
                        </div>

                        <div class="rounded-xl bg-grayBg border border-gray-200 p-3 md:p-4">
                            <div class="text-base md:text-xl font-bold">Безнал</div>
                            <div class="text-[11px] md:text-xs text-gray-600 mt-1">для организаций</div>
                        </div>
                    </div>

                    <div class="flex flex-wrap items-center gap-3" aria-label="Поддерживаемые платежные системы">
                        <IconPaymentVisa class="h-8 md:h-10 w-auto" aria-hidden="true"/>
                        <IconPaymentMasterCard class="h-8 md:h-10 w-auto" aria-hidden="true"/>
                        <IconPaymentMir class="h-8 md:h-10 w-auto" aria-hidden="true"/>
                        <IconPaymentMaestro class="h-8 md:h-10 w-auto" aria-hidden="true"/>
                        <IconPaymentSbp class="h-8 md:h-10 w-auto" aria-hidden="true"/>
                    </div>
                </div>
            </div>
        </section>

        <section class="bg-white border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-8 mb-5 md:mb-8">
            <div class="grid lg:grid-cols-[0.7fr_1.3fr] gap-5 md:gap-8">
                <div>
                    <h2 class="text-xl md:text-3xl font-bold mb-3 md:mb-4">
                        Как проходит оплата
                    </h2>

                    <p class="text-sm md:text-base text-gray-700">
                        Простая схема без лишних действий. Сначала согласуем заказ, потом фиксируем сумму и способ
                        оплаты.
                    </p>
                </div>

                <div class="grid md:grid-cols-4 gap-3 md:gap-4">
                    <div v-for="step in paymentSteps"
                         :key="step.number"
                         class="relative bg-grayBg border border-gray-200 rounded-xl md:rounded-2xl p-4 md:p-5">
                        <div class="text-2xl md:text-3xl font-bold text-baseColor mb-2">
                            {{ step.number }}
                        </div>

                        <h3 class="font-bold mb-2">
                            {{ step.title }}
                        </h3>

                        <p class="text-sm text-gray-700">
                            {{ step.text }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <div class="grid grid-cols-12 gap-4 md:gap-5 mb-5 md:mb-8">
            <section class="col-span-12 lg:col-span-4 bg-grayBg border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-6">
                <div class="w-10 h-10 rounded-xl bg-baseColor flex items-center justify-center mb-4">
                    <IconCalculator class="w-5 h-5"/>
                </div>

                <h2 class="text-xl md:text-2xl font-bold mb-4">
                    Расчет и счет
                </h2>

                <p class="text-sm md:text-base text-gray-700">
                    После заявки менеджер уточнит номенклатуру, объемы, адрес и сроки. Затем подготовит расчет и счет
                    на оплату.
                </p>
            </section>

            <section class="col-span-12 lg:col-span-4 bg-grayBg border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-6">
                <div class="w-10 h-10 rounded-xl bg-baseColor flex items-center justify-center mb-4">
                    <IconCheckMark class="w-5 h-5"/>
                </div>

                <h2 class="text-xl md:text-2xl font-bold mb-4">
                    Документы
                </h2>

                <ul class="space-y-2.5 text-sm md:text-base text-gray-700">
                    <li v-for="document in documents" :key="document">
                        {{ document }}
                    </li>
                </ul>
            </section>

            <section class="col-span-12 lg:col-span-4 bg-grayBg border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-6">
                <div class="w-10 h-10 rounded-xl bg-baseColor flex items-center justify-center mb-4">
                    <IconDeliveryCar class="w-5 h-5"/>
                </div>

                <h2 class="text-xl md:text-2xl font-bold mb-4">
                    Отгрузка
                </h2>

                <p class="text-sm md:text-base text-gray-700">
                    После оплаты организуем доставку на объект или подготовим заказ к самовывозу. Сроки согласуются до
                    отгрузки.
                </p>
            </section>
        </div>

        <section class="grid grid-cols-12 gap-4 md:gap-5 mb-5 md:mb-8">
            <div class="col-span-12 lg:col-span-7">
                <div class="bg-white border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-8 h-full">
                    <h2 class="text-xl md:text-3xl font-bold mb-4">
                        Важные условия
                    </h2>

                    <ul class="space-y-3 text-sm md:text-base text-gray-700">
                        <li v-for="condition in conditions" :key="condition">
                            {{ condition }}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-span-12 lg:col-span-5">
                <div class="relative overflow-hidden bg-black text-white rounded-2xl md:rounded-3xl p-4 md:p-8 h-full">
                    <div class="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_80%_20%,rgba(255,186,0,0.8),transparent_35%)]"></div>

                    <div class="relative z-[2]">
                        <h2 class="text-xl md:text-3xl font-bold mb-4">
                            Нужно быстро получить счет?
                        </h2>

                        <p class="text-sm md:text-base text-white/80 mb-5">
                            Отправьте список материалов. Мы проверим наличие, рассчитаем стоимость и подготовим счет на
                            оплату.
                        </p>

                        <button
                            @click.prevent="callbackStore.showBaseCallbackPopup"
                            class="max-md:w-full flex justify-center items-center text-center border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-xs md:text-sm px-5 md:px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                            Получить счет
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <section class="bg-grayBg border border-gray-200 rounded-2xl md:rounded-3xl p-4 md:p-8 mb-5 md:mb-8">
            <h2 class="text-xl md:text-2xl font-bold mb-4">
                Полезные разделы
            </h2>

            <div class="flex flex-wrap gap-3">
                <Link :href="route('deliveryAndShipping')"
                      class="max-md:w-full flex justify-center items-center text-center border-2 border-baseColor bg-transparent md:hover:bg-baseColor font-bold rounded-lg text-xs md:text-sm px-5 md:px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                    Доставка и отгрузка
                </Link>

                <Link :href="route('contacts')"
                      class="max-md:w-full flex justify-center items-center text-center border-2 border-baseColor bg-transparent md:hover:bg-baseColor font-bold rounded-lg text-xs md:text-sm px-5 md:px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                    Контакты
                </Link>

                <Link :href="route('priceList')"
                      class="max-md:w-full flex justify-center items-center text-center border-2 border-baseColor bg-transparent md:hover:bg-baseColor font-bold rounded-lg text-xs md:text-sm px-5 md:px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                    Прайс-лист
                </Link>
            </div>
        </section>
    </div>
</template>

<style scoped>
</style>
